import React, { Component } from 'react';

import DeepSearchSelect from 'modules/userManager/userSearch/deepSearch/commons/DeepSearchSelect';
import PropTypes from 'prop-types';

import './PlusAccess.scss';

export default class PlusAccess extends Component {
  static propTypes = {
    fields: PropTypes.object,
    cleanData: PropTypes.func,
    options: PropTypes.object,
    setValueSelect: PropTypes.func,
    onMenuOpen: PropTypes.func,
    accessPlusAllValue: PropTypes.string,
    userPlusAccessValue: PropTypes.string,
    setFieldValuePlusAll: PropTypes.func,
    isAccessPlusUserDisabled: PropTypes.bool,
    isAccessPlusAllOpen: PropTypes.bool,
    isUserPlusAccessOpen: PropTypes.bool
  };

  cleanField = (field) => {
    const { cleanData } = this.props;

    cleanData && field && cleanData(field);
  };

  onChange = (value, field) => {
    const { setValueSelect } = this.props;

    if (value) {
      setValueSelect && setValueSelect(value, field);
    } else {
      this.cleanField(field);
    }
  };

  render() {
    const {
      fields,
      options,
      onMenuOpen,
      setValueSelect,
      accessPlusAllValue,
      userPlusAccessValue,
      setFieldValuePlusAll,
      isAccessPlusUserDisabled
    } = this.props;

    return (
      <div className="deep__search__plus__acess">
        <DeepSearchSelect
          name="access_plus_all"
          field={fields.accessPlusAll}
          placeholder="users_manager.users_list.header.tab_all_users"
          onMenuOpen={onMenuOpen}
          options={options.accessPlusAllList}
          setValueSelect={setValueSelect}
          value={accessPlusAllValue}
          setFieldValue={setFieldValuePlusAll}
        />

        <DeepSearchSelect
          name="access_plus_user"
          field={fields.userPlusAccess}
          placeholder="users_manager.deep_search.access.access_plus_type_placeholder"
          onMenuOpen={onMenuOpen}
          options={options.userPlusAccessList}
          setValueSelect={setValueSelect}
          value={userPlusAccessValue}
          className="access__plus__type__select"
          isDisabled={isAccessPlusUserDisabled}
        />
      </div>
    );
  }
}
